import {
  useMutation,
  useQueryClient,
  type UseMutationOptions,
} from '@tanstack/react-query';
import service from '../service';
import type { ToastGuid, CreateToastGuidPayload } from '../types/toastGuid';
import { toastGuidQueryKeys } from './useToastGuids';

export function useCreateToastGuid(
  options?: UseMutationOptions<ToastGuid, Error, CreateToastGuidPayload>,
) {
  const queryClient = useQueryClient();
  const { onSuccess, ...restOptions } = options ?? {};

  return useMutation({
    mutationKey: ['toastGuid', 'create'],
    mutationFn: async (payload: CreateToastGuidPayload) => {
      return service.createToastGuid(payload);
    },
    retry: (failureCount, error: any) => {
      const status =
        error?.status ??
        error?.response?.status ??
        error?.cause?.status ??
        null;
      const isServerOrNetwork = status == null || status >= 500;
      return failureCount < 2 && isServerOrNetwork;
    },
    ...restOptions,
    onSuccess: (data, variables, context, mutation) => {
      queryClient.invalidateQueries({ queryKey: toastGuidQueryKeys.all });
      onSuccess?.(data, variables, context, mutation);
    },
  });
}
